
import React from 'react';
import { MyComponentType } from '../component-factory/component-types';
import { ComponentIdEnum } from '../component-factory/ComponentIdEnum';
import { ElementConfigType } from '../store/PageEditorStore';

type Props = ElementConfigType;
const RichTextComponent: MyComponentType<Props> = (props: Props) => {
//   const newProps = { ...props };

//   pageEditorStore.setConfigNode(newProps);
  const { styles, parentNodeIsBody } = props;
  return (
    <div
      style={Object.assign(parentNodeIsBody ? { paddingTop: 16, paddingBottom: 16 } : {}, styles)}
      dangerouslySetInnerHTML={{ __html: props.privateSchema?.html }}
    />
  );
};

RichTextComponent.definition = {
  id: ComponentIdEnum.RICH_TEXT_COMPONENT,
  name: '富文本组件',
  icon: 'https://cdn.resource.youniverse.cc/d2c-app-dev/dIVTg-dEwgXAOViujW2tP.png?image_process=resize,w_200',
  position: 13, // 显示顺序
  config: {
    text: 'Why Choose FEZIBO?',
  },
  styles: {},
  privateSchema: {
    editorState: {},
    html: '<h1>占位，不要把富文本编辑器的内容删到没有</h1><h1>占位，不要把富文本编辑器的内容删到没有</h1><h1>占位，不要把富文本编辑器的内容删到没有</h1>',
  },
};

export { RichTextComponent };
